module.exports = __webpack_public_path__ + "static/img/__biking.bdd6570.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__biking.jpg
// module id = YIcD
// module chunks = 0